import { render, staticRenderFns } from "./IntroText.vue?vue&type=template&id=306f8eca&scoped=true&"
import script from "./IntroText.vue?vue&type=script&lang=js&"
export * from "./IntroText.vue?vue&type=script&lang=js&"
import style0 from "./IntroText.vue?vue&type=style&index=0&id=306f8eca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f8eca",
  null
  
)

export default component.exports